export class Pisos {
  id!: number;
  nombrePiso!: string | undefined;
  descripcion!: string | undefined;
  ubicacion!: string | undefined;
  idCategoria !: string | undefined;
  rolAccess !: string | undefined;
}
